const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];

            if (variant) {
              const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              
              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  } 
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();                                    
                    }
                  }, 200);
                }
              }
            }
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
colorSwatches();
})()

function initParse() {
    console.log('parse');
    function hideOptionIDsAndPrices() {
        $('.pplrlabel, .product__description__property.order-summary__small-text, select.pplr_select option, .img_thumb_dropdown span.img_dropdown, .pplr-selecter-selected, span.ppdata').each(function(index, element) {
            var labelSplit = $(element).html();
            console.log('start hide option IDs');
            if (labelSplit.indexOf("|") >= 0) {
                var idSplit = labelSplit.split("|");
                $(element).html(idSplit[0]);
                var skudata = $.trim(idSplit[1])
                $(element).attr({'data-option-sku':skudata});
                $(element).parent().addClass('pplr_option-sku');
            }
        });
    }
    function changeOption(){
      $('.pplr_option-sku').each(function(index, element) {
        var myVar = $(this);
        selectedSKU(myVar);
      })
      $('.pplr_option-sku').change(function () {
        var myVar = $(this);
        selectedSKU(myVar);
      });
    }
    function selectedSKU(myOption) {
        var currentOp = myOption.find(':selected').data('optionSku');
        var optionName = myOption.attr('name');
        optionName = optionName.toLowerCase();
        if (typeof(currentOp) == "undefined"){
          currentOp = '';
        }
        //console.log(currentOp+' - '+optionName);
        
        if (optionName.indexOf("heat") >= 0) {
          $('.heat_opt').text(currentOp);
        }
        if (optionName.indexOf("ventilation") >= 0) {
          $('.ventilation_opt').text(currentOp);
        }
        if (optionName.indexOf("dehumidification") >= 0) {
          $('.dehumidification_opt').text(currentOp);
        }
        if (optionName.indexOf("controls") >= 0) {
          $('.controls_opt').text(currentOp);
        }
        if (optionName.indexOf("operating") >= 0) {
          $('.operating_opt').text(currentOp);
        }
        if (optionName.indexOf("quality") >= 0) {
          $('.quality_opt').text(currentOp);
        }
        if (optionName.indexOf("air flow") >= 0) {
          $('.air-flow_opt').text(currentOp);
        }
        if (optionName.indexOf("compressor location") >= 0) {
          $('.compressor-location_opt').text(currentOp);
        }
        if (optionName.indexOf("filter") >= 0) {
          $('.filter_opt').text(currentOp);
        }
        if (optionName.indexOf("corrosion protection") >= 0) {
          $('.corrosion-protection_opt').text(currentOp);
        }
        if (optionName.indexOf("engineering revision") >= 0) {
          $('.engineering-revision_opt').text(currentOp);
        }
        if (optionName.indexOf("cabinet color") >= 0) {
          $('.cabinet-color_opt').text(currentOp);
        }
    }
                           
    hideOptionIDsAndPrices();
    changeOption();
  $('.replacement_alert .list-click').click(function() {
    $('.replacement_alert').toggleClass('full');
  })
}
function returnLabel(array) {
    var html = '';
    html += array[array.length - 1]
    return html;
}
$(window).on('load', function() {
    initParse();
});